export default "__VITE_ASSET__a9e4f981__"